module.exports = __webpack_public_path__ + "img/18.93f2a168.jpg";